import { makeParamsObjFromSassMap, makeParamsObj } from '../../utils/helpers';
import { UI } from '../../utils';
import css from './Button.sass';
export var localPropsMap =
/*#__PURE__*/
makeParamsObjFromSassMap(css.props);
export var breakpoint =
/*#__PURE__*/
makeParamsObj(UI.BREAKEPOINTS);
export var SIZES_ROUND =
/*#__PURE__*/
makeParamsObjFromSassMap(css.sizesRound);
export var WIDTHS =
/*#__PURE__*/
makeParamsObjFromSassMap(css.widths);
export var HEIGHTS =
/*#__PURE__*/
makeParamsObjFromSassMap(css.heights);
export var THEMES =
/*#__PURE__*/
makeParamsObjFromSassMap(css.themes);
export var SIZES = {
  'l': ['l', {
    'fsize': 'l',
    'fsizeM': 'm',
    'height': '60',
    'heightM': '56',
    'heightS': '52',
    'paddingLeft': '36',
    'paddingRight': '36',
    'paddingLeftM': '28',
    'paddingRightM': '28',
    'paddingLeftS': '24',
    'paddingRightS': '24'
  }],
  'm': ['m', {
    'fsize': 'm',
    'height': '52',
    'paddingLeft': '32',
    'paddingRight': '32',
    'paddingLeftM': '24',
    'paddingRightM': '24',
    'paddingLeftS': '20',
    'paddingRightS': '20'
  }],
  's': ['s', {
    'fsize': 's',
    'height': '40',
    'paddingLeft': '28',
    'paddingRight': '28',
    'paddingLeftM': '20',
    'paddingRightM': '20',
    'paddingLeftS': '16',
    'paddingRightS': '16'
  }]
};
export var THEMES_MAP = {
  primary: 'primary',
  secondary: 'secondary',
  whiteBg: 'white',
  opacity: 'opacityWhite'
};